import React from 'react';
import styled, { css } from 'styled-components';
import { color, screen } from 'theme';
import { useI18n } from 'hooks/useI18n';
import { Link as LinkScroll } from 'react-scroll';

const linkStyles = css`
  font-family: 'Archivo Narrow', sans-serif;
  font-weight: 400;
  font-size: clamp(18px, 1.2vw, 18px);
  text-transform: uppercase;
  color: ${color('black')};
  text-decoration: none;
  text-underline-position: from-font;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${screen('md2')}) {
    font-size: 19px;
    line-height: 19px;
    white-space: normal;
    text-align: left;
  }
`;

const Wrapper = styled.div`
  display: flex;
  height: clamp(40px, 6vw, 64px);
  align-items: stretch;
  cursor: pointer;
  min-width: 0;
  position: relative;
  border: none;
  outline: none;

  .button-body {
    background-color: #c5fe79;
    display: flex;
    align-items: center;
    padding: 0 clamp(8px, 1.5vw, 20px);
    flex: 1;
    border: none;
    outline: none;
    position: relative;
    z-index: 2;
    margin-right: -2px; /* Small overlap to bridge the gap from the body side */
  }

  .button-tail {
    width: clamp(30px, 5vw, 60px);
    background: url('/images/fredcon26/button-tail.svg') no-repeat 0 0;
    background-size: 100% 100%;
    flex-shrink: 0;
    margin-left: -8px; /* Increased overlap for larger scales */
    position: relative;
    z-index: 1;
    border: none;
    outline: none;

    @media (max-width: ${screen('md2')}) {
      background-image: url('/images/fredcon26/button-tail-mobile.svg');
      margin-left: -4px;
    }
  }

  a,
  button {
    ${linkStyles}
    outline: none !important;
    border: none !important;
    box-shadow: none !important;
  }
`;

const StyledLinkScroll = styled(LinkScroll)`
  ${linkStyles}
`;

interface Fredcon26TicketButtonProps {
  className?: string;
  href?: string;
  text?: string;
}

export const Fredcon26TicketButton: React.FC<Fredcon26TicketButtonProps> = ({
  className,
  href,
  text
}) => {
  const { t } = useI18n('fredcon26');
  const DEFAULT_LUMA_URL = 'https://luma.com/4vot95mb';
  const targetHref = href || DEFAULT_LUMA_URL;
  const isInternal = targetHref.startsWith('#');

  return (
    <Wrapper className={`${className} cursor-pointer`}>
      <div className="button-body">
        {isInternal ? (
          <StyledLinkScroll
            to={targetHref.substring(1)}
            duration={500}
            offset={-64}
            className="cursor-pointer"
            containerId="fredcon-page-wrapper"
          >
            {text || t('fredcon.get-ticket')}
          </StyledLinkScroll>
        ) : (
          <a
            href={targetHref}
            target="_blank"
            rel="noreferrer"
            className="cursor-pointer"
          >
            {text || t('fredcon.get-ticket')}
          </a>
        )}
      </div>
      <div className="button-tail" />
    </Wrapper>
  );
};
